import { render, staticRenderFns } from "./tableware.vue?vue&type=template&id=152235a4&scoped=true&"
import script from "./tableware.vue?vue&type=script&lang=js&"
export * from "./tableware.vue?vue&type=script&lang=js&"
import style0 from "./tableware.vue?vue&type=style&index=0&id=152235a4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "152235a4",
  null
  
)

export default component.exports